import React from 'react';

export const ExclamationIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 3C26.271 3 33 9.729 33 18C33 26.271 26.271 33 18 33C9.729 33 3 26.271 3 18C3 9.729 9.729 3 18 3ZM18 0C8.0595 0 0 8.0595 0 18C0 27.9405 8.0595 36 18 36C27.9405 36 36 27.9405 36 18C36 8.0595 27.9405 0 18 0ZM16.035 11.289C15.8865 10.0785 16.827 9 18.057 9C19.2135 9 20.1225 10.014 19.977 11.1765L18.8415 20.256C18.789 20.6805 18.4275 21 18 21C17.5725 21 17.211 20.6805 17.157 20.256L16.035 11.289ZM18 27.375C16.965 27.375 16.125 26.535 16.125 25.5C16.125 24.465 16.965 23.625 18 23.625C19.035 23.625 19.875 24.465 19.875 25.5C19.875 26.535 19.035 27.375 18 27.375Z" fill="#BD600F"/>
  </svg>
);

export const CheckIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 24C6 14.0589 14.0589 6 24 6C33.9412 6 42 14.0589 42 24C42 33.9412 33.9412 42 24 42C14.0589 42 6 33.9412 6 24Z" stroke="#32A310" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 26.0006L19.1565 28.4659C20.0733 30.4196 22.8096 30.5322 23.8837 28.6603L30 18" stroke="#32A310" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const RedCrossIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 24C6 14.0589 14.0589 6 24 6C33.9412 6 42 14.0589 42 24C42 33.9412 33.9412 42 24 42C14.0589 42 6 33.9412 6 24Z" stroke="#CC1313" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 18L30 30" stroke="#CC1313" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M30 18L18 30" stroke="#CC1313" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
